import type { IImage, IVideo } from './media';

export enum InputType {
  TEXT = 'text',
  IMAGE = 'image',
  VIDEO = 'video',
}

interface IBaseInput {
  type: InputType;
  id: string;
  title?: string;
}

export interface ITextInput extends IBaseInput {
  type: InputType.TEXT;
  value: string;
}

export interface IImageInput extends IBaseInput, Omit<IImage, 'src'> {
  type: InputType.IMAGE;
  src?: string | null;
  isLoading?: boolean;
  hasUploadError?: boolean;
}

export interface IVideoInput extends IBaseInput, Omit<IVideo, 'src'> {
  type: InputType.VIDEO;
  src?: string | null;
  isLoading?: boolean;
  hasUploadError?: boolean;
}

export type IInput = ITextInput | IImageInput | IVideoInput;
export type IMediaInput = IImageInput | IVideoInput;

export const isTextInput = (input: IInput): input is ITextInput =>
  input.type === InputType.TEXT;

export const isMediaInput = (input: IInput): input is IMediaInput =>
  input.type === InputType.IMAGE || input.type === InputType.VIDEO;
